module.exports = __webpack_public_path__ + "img/zhihuiyuanqu.052380a6.png";